import { render } from "./WorkAreaTableRowMenu.vue?vue&type=template&id=623fd194"
import script from "./WorkAreaTableRowMenu.vue?vue&type=script&lang=ts"
export * from "./WorkAreaTableRowMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script